import React from "react";
import { useTranslation } from "react-i18next";

import SectionTitle from "../shared/components/sectionTitle";
import ECOCard from "../shared/components/card";
import Loader from "../shared/components/loader";

import usePageFetcher from "../repository/usePageFetcher";
import { formatDateWithMoment } from "../shared/utils/dateTimeUtils";

import "./style.css";

const Projects = () => {
  const { t, i18n } = useTranslation();
  const { isLoading, data } = usePageFetcher("project/");

  return (
    <div className="project_wrapper">
      <div className="content_wrapper project_container">
        <SectionTitle title={t("Loyihalar")} />
        {isLoading ? (
          <Loader />
        ) : (
          <div className="project_card_wrapper">
            {data.map((project) => {
              return (
                <ECOCard
                  image={project.img}
                  title={project[`title_${i18n.language}`]}
                  description={project[`description_${i18n.language}`]}
                  date={formatDateWithMoment(project.created_at)}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
